import React from 'react';
import styles from './Modal.module.css';

function Modal(props){
    const handleClose = (e) => {
        e.stopPropagation();
        props?.onClose?.()
    }
    if(props.active){
        return(
            <>  
                <div className={styles.backdrop}></div>
                <div className={styles.modal} onClick={handleClose}>
                    <div className={`${styles.content} ${props.className}`} style={props.style} onClick={e => e.stopPropagation()}>
                        {props.children}
                    </div>
                </div>
            </>
        )
    }

    return null
}

export default Modal